import { EventState, Mesh, MeshBuilder, StandardMaterial } from '@babylonjs/core';
import { TextBlock } from '@babylonjs/gui';
import {
  Button3D,
  Container3D,
  GUI3DManager,
  HolographicButton,
  IButton3DCreationOptions,
  StackPanel3D,
  Vector3WithInfo,
} from '@babylonjs/gui/3D';
import earcut from 'earcut';
import { Game } from '../Game';
import { Gui } from './Gui';

export class Gui3D {
  manager: GUI3DManager;

  constructor(public game: Game) {
    this.manager = new GUI3DManager(this.game.scene);
  }

  createStackPanel(): StackPanel3D {
    const panel = new StackPanel3D();
    panel.margin = 0.1;
    this.manager.addControl(panel);
    return panel;
  }

  createHoloButton(
    container: Container3D,
    txt: string,
    imageUrl: string,
    callback: (eventData: Vector3WithInfo, eventState: EventState) => void,
    name?: string
  ): Button3D {
    const button = new HolographicButton(name);
    container.addControl(button);
    button.onPointerUpObservable.add(callback);
    button.text = txt;
    button.imageUrl = imageUrl;
    return button;
  }

  createButton(
    container: Container3D,
    txt: string,
    callback: (eventData: Vector3WithInfo, eventState: EventState) => void,
    name?: string,
    options?: IButton3DCreationOptions
  ): Button3D {
    const button = new Button3D(name, options);
    container.addControl(button);
    button.onPointerUpObservable.add(callback);

    const buttonMaterial: StandardMaterial = button.mesh.material as StandardMaterial;
    buttonMaterial.emissiveColor = Gui.backgroundColor;
    buttonMaterial.alpha = 0.75;

    const text = new TextBlock();
    text.text = txt;
    text.color = Gui.primaryColor.toHexString();
    text.fontSize = Gui.fontSizeL;
    button.content = text;

    button.pointerOutAnimation = () => {
      buttonMaterial.emissiveColor = Gui.backgroundColor;
    };

    button.pointerEnterAnimation = () => {
      buttonMaterial.emissiveColor = Gui.secondaryColor;
    };

    return button;
  }

  async text3D(name: string, text: string, size: number, depth: number): Promise<Mesh> {
    const fontData = await (await fetch('assets/fonts/Droid_Sans_Regular.json')).json(); // Providing you have a font data file at that location
    return MeshBuilder.CreateText(
      name,
      text,
      fontData,
      {
        size,
        resolution: 64,
        depth,
      },
      this.game.scene,
      earcut
    );
  }
}
